export default "__VITE_ASSET__DeOL1gyE__"